import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, NgModule, InjectionToken, ChangeDetectionStrategy, Inject, PLATFORM_ID } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { __awaiter } from 'tslib';
import * as i1 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HammerModule } from '@angular/platform-browser';

class BottomDrawerComponent {
    constructor(cd) {
        this.cd = cd;
        this.offset = 0;
        this.offsetTop = 0;
        this.threshold = 25;
        this.activated = new EventEmitter();
        this.deactivated = new EventEmitter();
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
        this.dragEnded = new EventEmitter();
        this.move = new EventEmitter();
    }
    get freeDragPosition() {
        return {
            x: 0,
            y: this.open ? 0 + this.offsetTop : window.innerHeight - this.handleHeight - this.offset,
        };
    }
    get handleHeight() {
        var _a, _b;
        return (_b = (_a = this.handleElement) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.clientHeight;
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = changes.active) === null || _a === void 0 ? void 0 : _a.isFirstChange())) {
                ((_b = changes.active) === null || _b === void 0 ? void 0 : _b.currentValue) ? this.activated.emit() : this.deactivated.emit();
            }
            if (!((_c = changes.open) === null || _c === void 0 ? void 0 : _c.isFirstChange())) {
                ((_d = changes.open) === null || _d === void 0 ? void 0 : _d.currentValue) ? this.opened.emit() : this.closed.emit();
            }
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.draggableDrawer.constrainPosition = this.constrain;
        });
    }
    constrain(point, ref) {
        const offsetY = point.y - ref.getFreeDragPosition().y;
        return point;
    }
    handleDragEnded(e) {
        this.dragEnded.emit(e.distance);
        const dragDown = e.distance.y > 0;
        // How far along the screen did we drag the drawer handle?
        const distancePerentage = (Math.abs(e.distance.y) / window.innerHeight) * 100;
        // Is the threshold rached? then toggle open state
        const thresholdReached = distancePerentage >= this.threshold;
        if (thresholdReached) {
            this.open = !dragDown;
        }
    }
    dragStarted(e) {
        // console.log(e);
    }
    onSwipeUp(e) {
        console.log(e);
    }
    onSwipeDown(e) {
        console.log(e);
    }
    moved(e) {
        this.move.emit(e.pointerPosition);
    }
}
BottomDrawerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BottomDrawerComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
BottomDrawerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: BottomDrawerComponent, selector: "fstr-bottom-drawer", inputs: { active: "active", open: "open", offset: "offset", offsetTop: "offsetTop", threshold: "threshold" }, outputs: { activated: "activated", deactivated: "deactivated", opened: "opened", closed: "closed", dragEnded: "dragEnded", move: "move" }, viewQueries: [{ propertyName: "handleElement", first: true, predicate: ["handle"], descendants: true, static: true }, { propertyName: "draggableDrawer", first: true, predicate: ["draggableDrawer"], descendants: true, static: true }], exportAs: ["fstrBottomDrawer"], usesOnChanges: true, ngImport: i0, template: "<div\r\n  class=\"fstr-bottom-drawer is--closed\"\r\n  [class.is--open]=\"open\"\r\n  [class.is--closed]=\"!open\"\r\n  [class.is--active]=\"active\"\r\n  [class.is--inactive]=\"!active\"\r\n  cdkDrag\r\n  [cdkDragLockAxis]=\"'y'\"\r\n  [cdkDragFreeDragPosition]=\"freeDragPosition\"\r\n  #draggableDrawer=\"cdkDrag\"\r\n  (cdkDragEnded)=\"handleDragEnded($event)\"\r\n  (cdkDragStarted)=\"dragStarted($event)\"\r\n>\r\n  <div class=\"fstr-bottom-drawer__handle\" #handle cdkDragHandle>\r\n    <ng-content #handle select=\".fstr-drawer-handle\"></ng-content>\r\n  </div>\r\n  <ng-content #mainContent></ng-content>\r\n</div>\r\n", directives: [{ type: i1.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i1.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BottomDrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fstr-bottom-drawer', exportAs: 'fstrBottomDrawer', encapsulation: ViewEncapsulation.None, template: "<div\r\n  class=\"fstr-bottom-drawer is--closed\"\r\n  [class.is--open]=\"open\"\r\n  [class.is--closed]=\"!open\"\r\n  [class.is--active]=\"active\"\r\n  [class.is--inactive]=\"!active\"\r\n  cdkDrag\r\n  [cdkDragLockAxis]=\"'y'\"\r\n  [cdkDragFreeDragPosition]=\"freeDragPosition\"\r\n  #draggableDrawer=\"cdkDrag\"\r\n  (cdkDragEnded)=\"handleDragEnded($event)\"\r\n  (cdkDragStarted)=\"dragStarted($event)\"\r\n>\r\n  <div class=\"fstr-bottom-drawer__handle\" #handle cdkDragHandle>\r\n    <ng-content #handle select=\".fstr-drawer-handle\"></ng-content>\r\n  </div>\r\n  <ng-content #mainContent></ng-content>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { active: [{
                type: Input
            }], open: [{
                type: Input
            }], offset: [{
                type: Input
            }], offsetTop: [{
                type: Input
            }], threshold: [{
                type: Input
            }], activated: [{
                type: Output
            }], deactivated: [{
                type: Output
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], dragEnded: [{
                type: Output
            }], move: [{
                type: Output
            }], handleElement: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }], draggableDrawer: [{
                type: ViewChild,
                args: ['draggableDrawer', { static: true }]
            }] } });

class BottomDrawerModule {
}
BottomDrawerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BottomDrawerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BottomDrawerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BottomDrawerModule, declarations: [BottomDrawerComponent], imports: [CommonModule,
        DragDropModule,
        HammerModule], exports: [BottomDrawerComponent] });
BottomDrawerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BottomDrawerModule, imports: [[
            CommonModule,
            DragDropModule,
            HammerModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: BottomDrawerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BottomDrawerComponent],
                    imports: [
                        CommonModule,
                        DragDropModule,
                        HammerModule
                    ],
                    exports: [BottomDrawerComponent]
                }]
        }] });

/**
 * This is not a real service, but it looks like it from the outside.
 * It's just an InjectionTToken used to import the config object, provided from the outside
 */
const IconConfigService = new InjectionToken('IconConfig');

class IconComponent {
    /**
     *
     */
    constructor(config) {
        this.config = config;
        this.baseUrl = '/assets/';
        if (!config && !config.spritesheetUrl) {
            console.error('No spritesheet URL defined');
        }
        this.baseUrl = config.spritesheetUrl;
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: IconComponent, deps: [{ token: IconConfigService }], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: IconComponent, selector: "fstr-icon", inputs: { anchor: "anchor", title: "title" }, ngImport: i0, template: `
    <span class="icon is--{{ anchor }}">
      <span *ngIf="title" class="sr-only">{{ title }}</span>
      <svg class="icon-svg" aria-hidden="true">
        <use [attr.xlink:href]="baseUrl + '#' + anchor"></use>
      </svg>
    </span>
  `, isInline: true, directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{
                    // tslint:disable-next-line: component-selector
                    selector: 'fstr-icon',
                    template: `
    <span class="icon is--{{ anchor }}">
      <span *ngIf="title" class="sr-only">{{ title }}</span>
      <svg class="icon-svg" aria-hidden="true">
        <use [attr.xlink:href]="baseUrl + '#' + anchor"></use>
      </svg>
    </span>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [IconConfigService]
                    }] }];
    }, propDecorators: { anchor: [{
                type: Input
            }], title: [{
                type: Input
            }] } });

class IconModule {
    static forRoot(config) {
        return {
            ngModule: IconModule,
            providers: [
                {
                    provide: IconConfigService,
                    useValue: config,
                },
            ],
        };
    }
}
IconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: IconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: IconModule, declarations: [IconComponent], imports: [CommonModule], exports: [IconComponent] });
IconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: IconModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IconComponent],
                    exports: [IconComponent],
                    imports: [CommonModule],
                }]
        }] });

var YoutubeState;
(function (YoutubeState) {
    YoutubeState[YoutubeState["Unstarted"] = -1] = "Unstarted";
    YoutubeState[YoutubeState["Ended"] = 0] = "Ended";
    YoutubeState[YoutubeState["Playing"] = 1] = "Playing";
    YoutubeState[YoutubeState["Paused"] = 2] = "Paused";
    YoutubeState[YoutubeState["Buffering"] = 3] = "Buffering";
    YoutubeState[YoutubeState["Cued"] = 5] = "Cued";
})(YoutubeState || (YoutubeState = {}));

class YoutubeUtility {
    static VideoIdFromUrl(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = url.match(regExp);
        return match && match[7].length === 11 ? match[7] : url;
    }
}

class YoutubePlayerComponent {
    constructor(platformId) {
        this.platformId = platformId;
        this.ready = new EventEmitter();
        this.play = new EventEmitter();
        this.end = new EventEmitter();
        this.pause = new EventEmitter();
        this.change = new EventEmitter();
        this.error = new EventEmitter();
        this.stateClassName = 'is--unloaded';
    }
    get host() {
        console.log(this.cookies);
        return !this.cookies ? 'https://www.youtube-nocookie.com' : null;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isPlatformBrowser(this.platformId)) {
                return;
            }
            const YT = yield this.apiLoaded();
            this.player = new YT.Player(this.ref.nativeElement, {
                videoId: YoutubeUtility.VideoIdFromUrl(this.src),
                host: this.host,
                playerVars: this.config,
                events: {
                    onReady: (e) => this.ready.emit(e),
                    onError: (e) => this.error.emit(e),
                    onStateChange: (e) => {
                        const stateName = YoutubeState[e.data].toLowerCase();
                        this.stateClassName = `is--${stateName}`;
                        if (e.data === YoutubeState.Playing) {
                            this.play.emit(e);
                        }
                        if (e.data === YoutubeState.Paused) {
                            this.pause.emit(e);
                        }
                        if (e.data === YoutubeState.Ended) {
                            this.end.emit(e);
                        }
                        this.change.emit(e);
                    },
                },
            });
        });
    }
    apiLoaded() {
        return new Promise((resolve, reject) => {
            const tag = document.createElement('script');
            tag.id = 'youtube-component-api';
            tag.src = 'https://www.youtube.com/iframe_api';
            const exist = document.getElementById(tag.id);
            if (!exist) {
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
            let timeout = 0;
            const maxTimeout = 30000;
            const interval = 100;
            const timer = setInterval(() => {
                const YT = window.YT;
                timeout += interval;
                if (timeout >= maxTimeout) {
                    clearInterval(timer);
                    reject(new Error('Youtube Api not loaded'));
                }
                else if (YT && YT.Player) {
                    clearInterval(timer);
                    resolve(YT);
                }
            }, interval);
        });
    }
}
YoutubePlayerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: YoutubePlayerComponent, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
YoutubePlayerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: YoutubePlayerComponent, selector: "fstr-youtube-player", inputs: { src: "src", config: "config", cookies: "cookies" }, outputs: { ready: "ready", play: "play", end: "end", pause: "pause", change: "change", error: "error" }, viewQueries: [{ propertyName: "ref", first: true, predicate: ["ref"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"fstr-youtube__container {{ stateClassName }}\">\r\n  <div class=\"fstr-youtube__container__iframe\" #ref></div>\r\n</div>\r\n", styles: [".fstr-youtube__container{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}::ng-deep .fstr-youtube__container__iframe{width:100%;height:100%;position:absolute;top:0;right:0;bottom:0;left:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: YoutubePlayerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fstr-youtube-player', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"fstr-youtube__container {{ stateClassName }}\">\r\n  <div class=\"fstr-youtube__container__iframe\" #ref></div>\r\n</div>\r\n", styles: [".fstr-youtube__container{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}::ng-deep .fstr-youtube__container__iframe{width:100%;height:100%;position:absolute;top:0;right:0;bottom:0;left:0}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [PLATFORM_ID]
                    }] }];
    }, propDecorators: { src: [{
                type: Input
            }], config: [{
                type: Input
            }], cookies: [{
                type: Input
            }], ready: [{
                type: Output
            }], play: [{
                type: Output
            }], end: [{
                type: Output
            }], pause: [{
                type: Output
            }], change: [{
                type: Output
            }], error: [{
                type: Output
            }], ref: [{
                type: ViewChild,
                args: ['ref', { static: true }]
            }] } });

class YoutubePlayerModule {
}
YoutubePlayerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: YoutubePlayerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
YoutubePlayerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: YoutubePlayerModule, declarations: [YoutubePlayerComponent], imports: [CommonModule], exports: [YoutubePlayerComponent] });
YoutubePlayerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: YoutubePlayerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: YoutubePlayerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [YoutubePlayerComponent],
                    imports: [CommonModule],
                    exports: [YoutubePlayerComponent],
                }]
        }] });

class Html5VideoComponent {
    constructor() {
        this.playerVars = {};
        this.playsinline = true;
        // tslint:disable: no-output-rename
        // tslint:disable: no-output-on-prefix
        this.load = new EventEmitter();
        this.ready = new EventEmitter();
        this.onPlay = new EventEmitter();
        this.onPause = new EventEmitter();
        this.playerDefaults = {
            autoplay: false,
            controls: true,
            muted: false,
            loop: false,
        };
        this.isLoaded = false;
        this.stateClassName = 'is--unloaded';
    }
    log(e) {
        console.log(e);
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.playerVars = Object.assign(this.playerDefaults, this.playerVars);
        });
    }
    ngOnChanges(changes) {
        const videoEl = this.ref.nativeElement;
        // Set isLoaded true when video is ready to play
        this.isLoaded = videoEl.readyState === 4;
        videoEl.muted = this.playerVars.muted;
        if (!this.playerVars.autoplay) {
            this.play ? this.ref.nativeElement.play() : this.ref.nativeElement.pause();
        }
    }
    play() {
        this.ref.nativeElement.play();
    }
    pause() {
        this.ref.nativeElement.pause();
    }
    togglePlay() {
        const videoEl = this.ref.nativeElement;
        if (videoEl.paused) {
            this.play();
        }
        else {
            this.pause();
        }
    }
    _volumeChange(event) {
        const videoEl = this.ref.nativeElement;
        this.playerVars = Object.assign(this.playerVars, { muted: videoEl.muted });
    }
}
Html5VideoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: Html5VideoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
Html5VideoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: Html5VideoComponent, selector: "fstr-html5-video", inputs: { src: "src", playerVars: "playerVars", poster: "poster", playsinline: "playsinline" }, outputs: { load: "load", ready: "ready", onPlay: "play", onPause: "pause" }, viewQueries: [{ propertyName: "ref", first: true, predicate: ["videoBg"], descendants: true, static: true }], exportAs: ["fstrHtml5Video"], usesOnChanges: true, ngImport: i0, template: "<div class=\"fstr-html5-video__container {{ stateClassName }}\">\r\n  <video\r\n    class=\"fstr-html5-video__container__video\"\r\n    [loop]=\"playerVars.loop\"\r\n    [muted]=\"playerVars.muted\"\r\n    [autoplay]=\"playerVars.autoplay\"\r\n    [poster]=\"poster\"\r\n    [controls]=\"playerVars.controls\"\r\n    [src]=\"src\"\r\n    playsinline=\"playsinline\"\r\n    (load)=\"load.emit($event)\"\r\n    (play)=\"onPlay.emit($event)\"\r\n    (pause)=\"onPause.emit($event)\"\r\n    (canplay)=\"ready.emit($event)\"\r\n    (volumechange)=\"_volumeChange($event)\"\r\n    [class.is--loaded]=\"isLoaded\"\r\n    #videoBg\r\n  ></video>\r\n</div>\r\n", styles: [".fstr-html5-video__container{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}::ng-deep .fstr-html5-video__container__video{width:100%;height:100%;position:absolute;top:0;right:0;bottom:0;left:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: Html5VideoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fstr-html5-video', changeDetection: ChangeDetectionStrategy.OnPush, exportAs: 'fstrHtml5Video', template: "<div class=\"fstr-html5-video__container {{ stateClassName }}\">\r\n  <video\r\n    class=\"fstr-html5-video__container__video\"\r\n    [loop]=\"playerVars.loop\"\r\n    [muted]=\"playerVars.muted\"\r\n    [autoplay]=\"playerVars.autoplay\"\r\n    [poster]=\"poster\"\r\n    [controls]=\"playerVars.controls\"\r\n    [src]=\"src\"\r\n    playsinline=\"playsinline\"\r\n    (load)=\"load.emit($event)\"\r\n    (play)=\"onPlay.emit($event)\"\r\n    (pause)=\"onPause.emit($event)\"\r\n    (canplay)=\"ready.emit($event)\"\r\n    (volumechange)=\"_volumeChange($event)\"\r\n    [class.is--loaded]=\"isLoaded\"\r\n    #videoBg\r\n  ></video>\r\n</div>\r\n", styles: [".fstr-html5-video__container{width:100%;height:0;overflow:hidden;padding-bottom:56.25%;position:relative;display:block}::ng-deep .fstr-html5-video__container__video{width:100%;height:100%;position:absolute;top:0;right:0;bottom:0;left:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { src: [{
                type: Input
            }], playerVars: [{
                type: Input
            }], poster: [{
                type: Input
            }], playsinline: [{
                type: Input
            }], load: [{
                type: Output
            }], ready: [{
                type: Output
            }], onPlay: [{
                type: Output,
                args: ['play']
            }], onPause: [{
                type: Output,
                args: ['pause']
            }], ref: [{
                type: ViewChild,
                args: ['videoBg', { static: true }]
            }] } });

class Html5VideoPlayerModule {
}
Html5VideoPlayerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: Html5VideoPlayerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
Html5VideoPlayerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: Html5VideoPlayerModule, declarations: [Html5VideoComponent], imports: [CommonModule], exports: [Html5VideoComponent] });
Html5VideoPlayerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: Html5VideoPlayerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: Html5VideoPlayerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [Html5VideoComponent],
                    imports: [CommonModule],
                    exports: [Html5VideoComponent],
                }]
        }] });

class UiComponentsModule {
}
UiComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UiComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UiComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UiComponentsModule, imports: [BottomDrawerModule, YoutubePlayerModule, Html5VideoPlayerModule], exports: [BottomDrawerModule, YoutubePlayerModule, Html5VideoPlayerModule] });
UiComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UiComponentsModule, imports: [[BottomDrawerModule, YoutubePlayerModule, Html5VideoPlayerModule], BottomDrawerModule, YoutubePlayerModule, Html5VideoPlayerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UiComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [BottomDrawerModule, YoutubePlayerModule, Html5VideoPlayerModule],
                    exports: [BottomDrawerModule, YoutubePlayerModule, Html5VideoPlayerModule],
                }]
        }] });

/*
 * Public API Surface of ui-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BottomDrawerComponent, BottomDrawerModule, Html5VideoComponent, Html5VideoPlayerModule, IconComponent, IconModule, UiComponentsModule, YoutubePlayerComponent, YoutubePlayerModule, YoutubeUtility };
